'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = require('react-router');

var _FormButton = require('../../../components/form/FormButton');

var _FormButton2 = _interopRequireDefault(_FormButton);

var _FlexCenter = require('../../../components/misc/FlexCenter');

var _FlexCenter2 = _interopRequireDefault(_FlexCenter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UnsubscribeConfirm = function UnsubscribeConfirm(_ref) {
    var onUnsubscribeButtonClick = _ref.onUnsubscribeButtonClick;
    return _react2.default.createElement(
        _FlexCenter2.default,
        null,
        _react2.default.createElement(
            'h1',
            null,
            'Are you sure you want to downgrade your plan?'
        ),
        _react2.default.createElement(
            'p',
            null,
            'You\'ll still have access to all of your content, but you won\'t be able to add any more.'
        ),
        _react2.default.createElement(
            'div',
            { className: 'actions' },
            _react2.default.createElement(
                _FormButton2.default,
                { className: 'primary', onClickFn: onUnsubscribeButtonClick },
                'Yes, downgrade my plan'
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement(
                _reactRouter.Link,
                { to: '/account/plan' },
                'No, I\'ve changed my mind'
            )
        )
    );
};

UnsubscribeConfirm.propTypes = {
    onUnsubscribeButtonClick: _propTypes2.default.func
};

exports.default = UnsubscribeConfirm;


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/unsubscribe/UnsubscribeConfirm.js
// module id = 2099
// module chunks = 0